import { CustomerRole } from "./commonEnums";

export interface ApplicationCustomer {
	readonly phoneMobile?: string;
	readonly email?: string;
	readonly customerNumber?: string;
	readonly customerRole?: string;
	readonly isResident?: boolean;
	readonly isMainCustomer?: boolean;
}

export enum CustomerType {
	NotSet = 0,
	Private = 1,
	Business = 2,
	SelfEmployed = 3
}

export interface LimitedCustomerToUpdate {
	// Lookup/id fields
	customerId?: number;
	customerNumber?: string;
	// Updateable fields
	phoneMobile?: string;
	email?: string;
}

export interface LimitedCustomer extends LimitedCustomerToUpdate {
	customerId: number;
	customerName?: string;
	customerTypeId?: CustomerType;
}

export interface ApplicationCustomerDetailsDTO extends LimitedCustomer {
	customerRole: CustomerRole;
	isMainCustomerSpouse?: boolean;
	isMainCustomer?: boolean;
}
